import { Button, ButtonProps } from 'antd'
import { Link } from '@tanstack/react-router'
import React from 'react'
import { useTranslation } from 'react-i18next'

export type CampaignCreateButtonProps = {
    className?: string
} & ButtonProps

export function CampaignCreateButton({ className, ...props }: CampaignCreateButtonProps) {
    const { t } = useTranslation()

    return (
        <Link
            to="/campaigns/create"
            className={className}
        >
            <Button
                size="large"
                type="primary"
                {...props}
            >
                {t('Create {{name}}', { name: t('Campaign') })}
            </Button>
        </Link>
    )
}
